// extracted by mini-css-extract-plugin
export default {"moreToggle":"MenuMoreDropdown_moreToggle__zsamu"};